import { useState } from "react";
import axios from "axios";
import { setJwtToken } from "../config/axiosInstance";

// export const useFileDownloader = () => {
//   const downloadFile = async (buttonLoader, url, fileName, params = {}) => {
//     const { data } = params;

//     try {
//       buttonLoader(true);

//       const { headers } = setJwtToken();
//       const response = await axios.get(url, {
//         data,
//         responseType: "blob",
//         headers,
//       });

//       if (response.status === 200) {
//         const blob = new Blob([response.data], {
//           type: response.headers["content-type"],
//         });

//         const blobUrl = window.URL.createObjectURL(blob);

//         const link = document.createElement("a");
//         link.href = blobUrl;
//         link.download = fileName;

//         document.body.appendChild(link);

//         link.click();

//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(blobUrl);

//         buttonLoader(false);
//       } else {
//         throw new Error("File download failed");
//       }
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       // Handle error gracefully, e.g., display an error message to the user
//       buttonLoader(false);
//       if (axios.isCancel(error)) {
//         console.log("Request cancelled:", error.message);
//       } else {
//         console.error("Error:", error.message);
//       }
//     }
//   };

//   return { buttonLoader, downloadFile };
// };

export const useFileDownloader = () => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadFile = async (url, fileName, params = {}) => {
    setIsLoading(true);

    try {
      const { headers } = setJwtToken();

      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      }
      // Additional error handling logic, if needed
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, downloadFile };
};

export const useDownloadFilterFile = () => {
  const [loading, setLoading] = useState(false);

  const downloadFile = async (url, fileName, params = {}) => {
    try {
      setLoading(true);

      const { headers } = setJwtToken();

      // Convert params object to URL query string
      const queryString = new URLSearchParams(params.data).toString();
      const fullUrl = `${url}?${queryString}`;

      const response = await axios.get(fullUrl, {
        responseType: "blob",
        headers,
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        setLoading(false);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      // Handle error gracefully, e.g., display an error message to the user
      setLoading(false);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  return { loading, downloadFile };
};
